/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Modal,
  Select,
  Form,
  Space,
  Upload,
  Spin,
  Row,
  Col,
} from "antd";
import {
  AuditOutlined,
  BackwardOutlined,
  PlusCircleTwoTone,
  SaveOutlined,
} from "@ant-design/icons";
import "../../../components/AdminComponents/contactStyles.css";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  ClientMenu,
  SettingsMenu,
} from "../../../components/AdminComponents/MenuItems";
import { useParams, NavLink } from "react-router-dom";
import Axios from "../../../api/Axios";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;
const handleRowClick = () => {};
const record = null;
// eslint-disable-next-line no-lone-blocks
{
  /* <div style={{ display: "inline-block", marginLeft: "2rem" }}>
<Form.Item
name="profile_picture"
label={<p className="my-form-lables">Profile Picture</p>}
valuePropName="fileList"
getValueFromEvent={normFile}
style={{ width: "27rem" }}
>
<Upload
name="profile_picture"
action="/api/upload"
listType="picture"
>
<Button
icon={<UploadOutlined />}
style={{
width: "27.5rem",
background: "aliceblue",
border: "1px solid black",
}}
>
Click to upload
</Button>
</Upload>
</Form.Item>
</div> */
}
const NewUsers = () => {
  const history = useNavigate();
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const phoneInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [applications, setApplications] = useState([]);
  const [phone, setPhone] = useState("");
  const [additionalFieldsCount, setAdditionalFieldsCount] = useState(1);
  const [newRoles, setNewRoles] = useState();
  const [roles1, setRoles1] = useState([]);
  const [phoneObj, setPhoneObj] = useState(null);
  const [isUserIDExists, setIsUserIDExists] = useState(false);
  const [selectedApplications, setSelectedApplications] = useState([]);

  // const handleAppSelection = (value, index) => {
  //   setSelectedApplications((prevSelectedApplications) => {
  //     const updatedSelectedApplications = [...prevSelectedApplications];
  //     updatedSelectedApplications[index] = value;
  //     return updatedSelectedApplications;
  //   });
  // };
  const handleAppSelection = (value, index) => {
    //console.log(value, index);
    setSelectedApplications((prevSelectedApplications) => {
      const updatedSelectedApplications = [...prevSelectedApplications];
      updatedSelectedApplications[index] = value;
      return updatedSelectedApplications;
    });
    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    const selectedApp = applications.find((app) => app.id === value);
    //console.log(applications);
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      if (selectedApp) {
        // set the roles for the selected application
        updatedRoles[index] = selectedApp.roles;
      } else {
        updatedRoles[index] = [];
      }
      return updatedRoles;
    });
  };
  const resetAppAnduser = (ele) => {
    //console.log(ele, "--------------------");
    formRef.current.setFieldsValue({ [`user_role[${ele}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${ele}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[ele] = [];
      return updatedRoles;
    });
  };

  const LoadApplications = async () => {
    try {
      const res = await Axios.get("/globaluserroleaccess/");
      //console.log(res.data);
      setApplications(res.data);
      setNewRoles(res.data);
      //console.log(res.data);
      //console.log(Math.min(res.data?.length || 0, 5));
      // setAdditionalFieldsCount(Math.min(res.data?.length || 0, 5));
      //console.log(additionalFieldsCount); // set maximum number of fields to 5 or the length of the data array, whichever is smaller
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const accessRef = useRef(false);
  const onFinish = async (values) => {
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    for (let i = 0; i < additionalFieldsCount; i++) {
      delete values[`applications[${i}]`];
      delete values[`user_role[${i}]`];
    }
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    //console.log(applications);
    const updatedValues = {
      ...normalizedValues,

      // applications: applications,
    };
    if (phone && phone.length > 4 && !phone.startsWith("+")) {
      updatedValues.phone_number = "+" + phone;
    } else if (phone && phone.length > 4 && phone.startsWith("+")) {
      updatedValues.phone_number = phone;
    } else {
      updatedValues.phone_number = "";
    }
    //console.log("Form values:", updatedValues);
    try {
      const res = await Axios.post("/globalusercreate/", updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      if (err?.response?.data?.detail?.phone_number) {
        CreateFailed(`${err?.response?.data?.detail?.phone_number}`);
      }
      // else if (err?.response?.data?.detail) {
      //   CreateFailed(err?.response?.data?.detail);
      // }
      else {
        CreateFailed("Admin has not been created");
      }
      //console.log(err.response.data.detail);
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Admin has been created.",
      duration: 5,
    });
    // LoadContacts();
    setTimeout(() => {
      history("/access-manager/admins");
    }, 5000);
  };
  const handleAccessReset = (index) => {
    // setAdditionalFieldsCount(0);
    //console.log("-------------------------------");
    //console.log(additionalFieldsCount);
    formRef.current.setFieldsValue({ access: false });

    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${index}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[index] = [];
      return updatedRoles;
    });
  };
  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `${props}`,
      duration: 5,
    });
  };
  const formRef = useRef();
  const handleSubmit = async (values) => {
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    //console.log(applications);
  };
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const handleFormChange = async (changedValues, allValues) => {
    if ("email" in changedValues && allValues.email.length > 3) {
      const response = await Axios.get(`/usercheck/?search=${allValues.email}`);
      //console.log(response);
      setIsUserIDExists(response.data.exists);
    }
  };
  const checkUserIDExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserIDExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserIDExists().then(resolve, reject);
        }, 100);
      } else if (isUserIDExists) {
        reject("Email ID already exists");
      } else {
        resolve();
      }
    });
  };
  useEffect(() => {
    //console.log(additionalFieldsCount);
    //console.log(roles1);
  }, [additionalFieldsCount, roles1]);
  const thirdMenuData = [
    {
      path: `/access-manager/admins/add-user`,
      name: "Add Admin",
      icon: (
        <PlusCircleTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <div>
      <Sidebar props={SettingsMenu}>
        {contextHolder}
        <SecondaryNav menuItems={thirdMenuData} />
        <div className="form-container-2">
          <Form
            name="complex-form"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={handleFormChange}
            ref={formRef}
            labelCol={{
              span: 25,
            }}
            wrapperCol={{
              span: 80,
            }}
            style={{
              width: "100%",
              marginBottom: "150px",
            }}
          >
            <div className="group1">
              <div className="form-heading">
                {capitalizeWords("ADD ADMIN INFO")}
              </div>
              <div className="antd-test-client" style={{ marginTop: "3rem" }}>
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">First Name</p>}
                    >
                      <Form.Item
                        name="first_name"
                        noStyle
                        rules={[
                          { required: true, message: "Username is required" },
                        ]}
                      >
                        <Input
                          className="my-form-input-antd-test"
                          placeholder={"Enter user name"}
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Last Name</p>}
                    >
                      <Form.Item name="last_name" noStyle initialValue={null}>
                        <Input
                          placeholder="Enter last name"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={6} xl={6}>
                    <Form.Item label={<p className="my-form-lables">Email</p>}>
                      <Form.Item
                        name="email"
                        noStyle
                        rules={[
                          {
                            message: "Enter a valid email",
                            type: "email",
                          },

                          {
                            validator: checkUserIDExists,
                            validateTrigger: "onChange",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Email"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div className="antd-test-client">
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <div style={{ display: "inline-block", marginLeft: "1rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Phone No.</p>}
                    >
                      <Space>
                        <Form.Item name="phone_number" noStyle>
                          <PhoneInput
                            // className="my-form-input"
                            ref={phoneInputRef}
                            placeholder="Enter your Phone No."
                            country="us"
                            value={phone}
                            // style={{ width: "27rem" }}
                            onChange={handlePhoneNumberChange}
                            onBlur={() => {
                              try {
                                const phoneObj =
                                  parsePhoneNumberFromString(phone);
                                setPhoneObj(phoneObj);
                              } catch (e) {
                                setPhoneObj(null);
                              }
                            }}
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                  <Col xs={24} sm={12} md={3} lg={5} xl={5}>
                    <Form.Item label={<p className="my-form-lables">Status</p>}>
                      <Input.Group compact>
                        <Form.Item name="status" noStyle initialValue={true}>
                          <Select
                            placeholder="Select Status"
                            className="my-form-input-antd-test"
                          >
                            <Option value={true}>Active</Option>
                            <Option value={false}>Inactive</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">User ID</p>}
                    >
                      <Space>
                        <Form.Item
                          name="user_id"
                          noStyle
                          initialValue={null}
                          rules={[
                            { required: true, message: "User ID is required" },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter user ID"
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {true && (
                // <div className="group-1-box" style={{ marginTop: "2rem" }}>
                <div className="antd-test-client">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={6} xl={6}>
                      <Form.Item
                        label={<p className="my-form-lables">Roles</p>}
                      >
                        <Form.Item name="roles" noStyle initialValue={[]}>
                          <Select
                            placeholder="Select Roles"
                            className="my-form-input-antd-test"
                            mode="multiple"
                            wi
                            // onChange={handleRoleSelection}
                          >
                            {newRoles?.map((role) => (
                              <Option key={role.id} value={role.id}>
                                {role.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                // </div>
              )}
            </div>
            <div style={{ display: "inline-block", marginLeft: "5rem" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history("/access-manager/admins");
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button type="primary" htmlType="button" onClick={handleReset}>
                  Reset
                </Button>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // className="my-form-input-end"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Save
                  <SaveOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Sidebar>
    </div>
  );
};

export default NewUsers;
